import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Api } from '../../../services/api';
import { FaCopy, FaTrash } from 'react-icons/fa';
import { BiPlusMedical } from 'react-icons/bi';

const LeadSourceConfig = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [projectType, setProjectType] = useState([]);
    const [searchProjectType, setSearchProjectType] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState('');

    const toast = useRef(null);
    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState(false);

    // -------------------------------------------------------------
    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    // -------------------------------------------------------------

    const formik = useFormik({
        initialValues: {
            title: '',
           Id: '',

        },

        validate: (data) => {
            let errors = {};

            if (!data.title) {
                errors.title = 'Lead Source is required.';
            } 
            return errors;
        },

        onSubmit: (data) => {
            const token = localStorage.getItem('authToken');
            const headers = {
                'Authorization': token ? `Bearer ${token}` : '',
                "Content-Type": "application/json",
            };


            var url = Api.API_BASE_URL + 'add-marketing';
            if (type == "Edit") {
                url = Api.API_BASE_URL + 'update-marketing/' + projectTypeID;
            }


            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                        closeModal();
                        getProjectType();
                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });

            console.log(data);
        }
    });
    // -------------------------------------------------------------

    const [type, setType] = useState('Add');
    const [title, setTitle] = useState('Add Project Type');
    const [projectTypeID, setProjectTypeID] = useState();
    const [selectedProduct, setSelectedProduct] = useState(null);


    const openModal = () => {
        setProjectTypeID('');
        formik.resetForm();
        setType('Add');
        setTitle('Add Project Type');
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setIsDeleteConfirmationModalOpen(false);
    };



    const editModal = (row) => {
        setProjectTypeID(row._id);
        // console.log('====>',projectTypeID);
        
        formik.setFieldValue('title', row.title);
        formik.setFieldValue('ProjectId', row.ProjectId);

        setType('Edit');
        setTitle('Edit Project Type');
        setIsModalOpen(true);
    };

    const openCopyModal = (row) => {
        formik.setFieldValue('title', row.title);
        formik.setFieldValue('ProjectId', row.ProjectId);
        setType('Add');
        setTitle('Copy Project Type');
        setIsModalOpen(true);
    };


    useEffect(() => {
        console.log('Fetching projects...xx');
        getProjectType();
    }, []);

    const getProjectType = (project) => {

        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };

        axios.get(Api.API_BASE_URL + 'get-marketing', { headers })
            .then((response) => {

                var data = response.data.result;
                setProjectType(data);
                setSearchProjectType(data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
                setIsLoading(false);
            });
     

    };



    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <div onClick={(e) => e.stopPropagation()}>
                    <FaCopy onClick={() => openCopyModal(rowData)} style={{ marginRight: '10px', color: 'orange' }} />
                    <FaTrash onClick={() => handleDeleteProject(rowData._id)} style={{ color: 'darkred' }} />
                </div>
            </React.Fragment>
        );
    };

    const handleDeleteProject = (projectId,) => {
        setProjectTypeID(projectId);
        setIsDeleteConfirmationModalOpen(true);
    };


    const confirmDelete = async () => {
        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };

        axios.get(Api.API_BASE_URL + 'delete-marketing/' + projectTypeID, { headers })
            .then((response) => {
                toast.current.show({ severity: 'info', summary: 'Confirmed', detail: response.data.result, life: 3000 });
                getProjectType();
                closeModal();
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
            });
    }

    const searchrole = (searchValue) => {
        console.log('searchValue', searchValue);

        setProjectType([]);
        const searchResult = searchProjectType.filter((item) =>
            item.title.toLowerCase().includes(searchValue.toLowerCase())
        );
        setProjectType(searchResult);
        console.log(searchResult)
    }

    const header = (
        <div className="flex flex-wrap  align-items-center justify-content-between m-2 ">
            <h4 > </h4>
            <div>
                <span className="p-input-icon-left ">
                    <InputText className="input-field" type="search" onChange={(e) => searchrole(e.target.value)} placeholder="Search..." />
                </span>
                <button type="button" title='Add a new project' style={{ cursor: 'pointer' }} onClick={openModal} className="custom-button m-2" >
                    <div className='flex gap-2 px-1 py-1' style={{ alignItems: 'center' }}>
                        <BiPlusMedical size={14} />
                        <span> ADD </span>
                    </div>
                </button>
            </div>
        </div>
    );

    const onRowSelect = (e) => {
        const rowData = e.data;
        editModal(rowData);
    };


    return (
        <>
           
            <div className="pagee-container mt-2">
                <Toast ref={toast} />
                <ConfirmDialog />
                <div className="pagination-datable-height">
                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (

                        <DataTable
                            value={projectType}
                            paginator
                            rows={14}
                            key="id"
                            tableStyle={{ minWidth: '50rem', }}
                            selectionMode="single"
                            selection={selectedProduct}
                            onRowSelect={onRowSelect}
                            onSelectionChange={(e) => setSelectedProduct(e.value)}
                            header={header}
                            globalFilter={globalFilter}
                            scrollHeight="flex"
                        >
                            <Column key="action" body={actionBodyTemplate} header="Action" exportable={false} style={{ width: '100px', alignItems: 'center', textAlign: 'center' }} />

                            <Column key="title" field="title" header="LEAD SOURCE" />

                        </DataTable>
                    )}
                </div>
            </div>
            {/* ---------------------------------------------------------------*/}
            <Dialog header="" visible={isModalOpen} maximizable style={{ width: '30vw' }} dismissableMask="true" onHide={() => { setIsModalOpen(false); setSelectedProduct(null); }}>
                <div className='p-2'>
                    <form onSubmit={formik.handleSubmit} className="" >
                        <div className="">

                            <div className="">
                                <div className='card-heading'>
                                    <label>LEAD SOURCE</label>
                                </div>

                                <InputText
                                    id="title"
                                    name="title"
                                    value={formik.values.title}
                                    onChange={(e) => {
                                        console.log(e.target.value);
                                        formik.setFieldValue('title', e.target.value);
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('title') })} style={{ width: '100%' }}
                                />
                            </div>

                        </div>
                        <div className="flex flex-wrap justify-content-center mt-5">
                            <Button label="Submit" type="submit" className=' customSave-button' />
                        </div>
                    </form>
                </div>
            </Dialog>

            {/* ---------------------------------------------------------------*/}

            {isDeleteConfirmationModalOpen && (
                <div className="modal">
                    <div className="small-modal-content">
                        <div className="modal-headerx">
                            <h5 className="modal-title">Delete Confirmation</h5>
                            <button className="modal-closex" onClick={closeModal}>
                                &times;
                            </button>
                        </div>
                        <div className="modal-bodyx">
                            <p>"Are you sure you want to delete this project? "</p>
                        </div>
                        <div className="modal-footer-cancelx">
                            <button className="cancel-buttonx" onClick={closeModal}>
                                Cancel
                            </button>
                            <button className="delete-buttonx" onClick={confirmDelete}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default LeadSourceConfig